import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { authActions } from './authSlice';
import { getShippingById, getShippingList } from '../../ApiServices/ShippingsService';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  selectedValue: null,
  rowsPerPage: 10,
  pageNo: 0,
  sortBy: '',
  sortDirection: 0,
  filter: {}
};

const shippingsSlice = createSlice({
  name: 'shippings',
  initialState: initialState,
  reducers: {
    clearShippingsState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchShippings.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchShippings.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchShippingById.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = action?.payload?.data;
    });
    builder.addCase(fetchShippingById.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.error = action?.payload;
    });
  }
});

export const shippingsState = (state: RootState) => state?.shippings;
export const { clearShippingsState } = shippingsSlice.actions;
export default shippingsSlice.reducer;

export const fetchShippings = createAsyncThunk(
  'shippings/fetchShippings',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_SHIPPINGS') }));
      let response: any = await getShippingList(payload);
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchShippingById = createAsyncThunk(
  'shippings/fetchShippingById',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_SHIPPINGS_DETAILS') }));
      let response: any = await getShippingById(payload);
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const downloadShippedOrders = createAsyncThunk(
  'orders/downloadShippedOrders',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('DOWNLOADING_ORDERS') }));
      let response: any = await getShippingList(payload);
      if (response === 200) dispatch(showSuccessSnackbar({ message: t('DOWNLOAD_SUCCESS') }));
      else dispatch(showErrorSnackbar({ message: t('DOWNLOAD_FAILS') }));
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const downloadShippingDetails = createAsyncThunk(
  'orders/downloadShippedOrders',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('DOWNLOADING_SHIPING_DETAILS') }));
      let response: any = await getShippingById(payload);
      if (response === 200) dispatch(showSuccessSnackbar({ message: t('DOWNLOAD_SUCCESS') }));
      else dispatch(showErrorSnackbar({ message: t('DOWNLOAD_FAILS') }));
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);